/** Display estimate, not a transaction deadline or proof of completion.
 * Two TEST observations took 61/63 seconds from detected GRIM to position.
 * 90 seconds leaves room for wallet broadcast and detection. Tune from timings.
 */
export const TREASURY_CONFIRMATION_UI = Object.freeze({ estimateSeconds: 90 });
